export default __webpack_public_path__ + "static/media/loadingMochi.81f4c902.svg";